import { createFileRoute } from "@tanstack/react-router";
import { EarnPage } from "../../features/staking/pages/earn-page";
import { assetRouteLoader } from "../../features/staking/utils/route-loaders";

export const Route = createFileRoute("/_layout/staking/$asset")({
  loader: assetRouteLoader,
  component: EarnPage,
});
